import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { profileData } from '../data/mock';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-16 px-4" style={{ background: 'var(--text-primary)', color: 'white' }}>
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-semibold mb-4">IndoHukum.id</h3>
            <p className="body-small opacity-80 mb-6 max-w-md">
              {profileData.tagline}
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 rounded-full border border-white border-opacity-30 flex items-center justify-center hover:bg-white hover:bg-opacity-10 transition-colors">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white border-opacity-30 flex items-center justify-center hover:bg-white hover:bg-opacity-10 transition-colors">
                <Twitter size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white border-opacity-30 flex items-center justify-center hover:bg-white hover:bg-opacity-10 transition-colors">
                <Linkedin size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white border-opacity-30 flex items-center justify-center hover:bg-white hover:bg-opacity-10 transition-colors">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 mb-4">Navigasi</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('profil')} className="body-small opacity-80 hover:opacity-100 transition-opacity">
                  Profil
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="body-small opacity-80 hover:opacity-100 transition-opacity">
                  Portfolio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('hukum-pedia')} className="body-small opacity-80 hover:opacity-100 transition-opacity">
                  Hukum Pedia
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('artikel')} className="body-small opacity-80 hover:opacity-100 transition-opacity">
                  Artikel
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pencarian')} className="body-small opacity-80 hover:opacity-100 transition-opacity">
                  Pencarian Peraturan
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('kontak')} className="body-small opacity-80 hover:opacity-100 transition-opacity">
                  Kontak
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-3 mb-4">Kontak</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <span className="body-small opacity-80">{profileData.contact.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span className="body-small opacity-80">{profileData.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span className="body-small opacity-80">{profileData.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white border-opacity-20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="body-small opacity-60">
            © 2024 IndoHukum.id. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="body-small opacity-60 hover:opacity-100 transition-opacity">
              Kebijakan Privasi
            </a>
            <a href="#" className="body-small opacity-60 hover:opacity-100 transition-opacity">
              Syarat & Ketentuan
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
